export default "__VITE_ASSET__CrKdlPw2__"